import { render, staticRenderFns } from "./ExpressaoValor.vue?vue&type=template&id=c4cac3f6&scoped=true"
import script from "./ExpressaoValor.vue?vue&type=script&lang=js"
export * from "./ExpressaoValor.vue?vue&type=script&lang=js"
import style0 from "./ExpressaoValor.vue?vue&type=style&index=0&id=c4cac3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cac3f6",
  null
  
)

export default component.exports